import React, { useState, useEffect } from 'react'
import Image from 'next/image'

import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import { Button } from '@/components/common'
import calendarLabel from '@/assets/days-of-neat/calendar-label.jpg'
import calendarTree from '@/assets/days-of-neat/calendar-tree.png'
import halfCircle from '@/assets/days-of-neat/half-circle.jpg'

import styles from './12-days-of-neat.module.scss'

const pageId = 'twelveDaysOfNeat'

const cards = [
  {
    title: 'LinkedIn Sweepstakes',
    text:
  <><p>Fill out the <a href="https://forms.gle/Fnd5u29JC5L34HLC6" rel="noreferrer" target="_blank">form</a>, and follow The Neat Company on <a href="https://www.linkedin.com/company/the-neat-company_2" rel="noreferrer" target="_blank">LinkedIn</a> to be entered into a sweepstakes to win an Amazon Gift Card</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Special Product Offer!',
    text:
  <><p>New Neat Customers: Get free VIP support when you purchase a <a href="https://www.neat.com/t?sku=neatvipyr&utm_campaign=12daysofneatday2" rel="noreferrer" target="_blank">Neat + VIP yearly</a> or <a href="https://www.neat.com/t?sku=neataivipyr&utm_campaign=12daysofneatday2" rel="noreferrer" target="_blank">Neat + AI + VIP yearly</a> plan.</p>
  </>,
  },
  {
    title: 'Mobile Acquisition Item Sweepstakes',
    text:
  <><p>Fill out the <a href="https://forms.gle/Fnd5u29JC5L34HLC6" rel="noreferrer" target="_blank">form</a>, and simply capture an item with your Neat mobile app to be automatically entered into the sweepstakes*</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Webinar - Using Neat to Declutter',
    text:
  <><p><a href="https://my.demio.com/ref/dbefY8jcQ8HDerde" rel="noreferrer" target="_blank">Register</a> to attend one of our webinars for a chance to win an Amazon Gift Card.</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Webinar - Top 5 Best Practices',
    text:
  <><p><a href="https://my.demio.com/ref/h7pHDvD4c0mQkcQh" rel="noreferrer" target="_blank">Register</a> to attend one of our webinars for a chance to win an Amazon Gift Card.</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Webinar - Neat Mobile App',
    text:
  <><p><a href="https://my.demio.com/ref/cbTP145wfotWcuoY" rel="noreferrer" target="_blank">Register</a> to attend one of our webinars for a chance to win an Amazon Gift Card.</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Webinar - Automate Expense Management WIth Transactions',
    text:
  <><p><a href="https://my.demio.com/ref/o5tqQgAIFAeOqanw" rel="noreferrer" target="_blank">Register</a> to attend one of our webinars for a chance to win an Amazon Gift Card.</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Webinar - Transaction Management',
    text:
  <><p><a href="https://my.demio.com/ref/NAQNua1JVqyGZkMb" rel="noreferrer" target="_blank">Register</a> to attend one of our webinars for a chance to win an Amazon Gift Card.</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Connected Bank Account Sweepstakes',
    text:
  <><p>For existing Neat Customers: Fill out the <a href="https://forms.gle/Fnd5u29JC5L34HLC6" rel="noreferrer" target="_blank">form</a>, and connect a bank account and stream transactions for a chance to win an Amazon Gift Card*. If you are not a current Automated Insights subscriber, get a risk-free, no credit card required <a href="/free-trial-ai-vip" rel="noreferrer" target="_blank">trial here</a> to begin connecting accounts and trying all the amazing features that Neat has to offer!</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Special Product Offer!',
    text:
  <><p>New Neat Customers: Get $50 off any Neat SKU when purchasing through the following <a href="https://www.neat.com/t?sku=neatyr&utm_campaign=12daysofneatday10" rel="noreferrer" target="_blank">link</a></p>
  </>,
  },
  {
    title: 'Facebook Follower Sweepstakes',
    text:
  <><p>Fill out the <a href="https://forms.gle/Fnd5u29JC5L34HLC6" rel="noreferrer" target="_blank">form</a>, and follow The Neat Company on <a href="https://www.facebook.com/NeatCompany/" rel="noreferrer" target="_blank">Facebook</a> to be entered into a sweepstakes to win an Amazon Gift Card</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
  {
    title: 'Newsletter Subscriber Sweepstakes',
    text:
  <><p>Fill out the <a href="https://forms.gle/Fnd5u29JC5L34HLC6" rel="noreferrer" target="_blank">form</a> to subscribe to the <a href="https://www.neat.com/#:~:text=Policy%20Center-,Subscribe,-Subscribe%20to%20get" rel="noreferrer" target="_blank">Neat Company newsletter</a> to be entered into a sweepstakes to win an Amazon Gift Card.</p>
  </>,
    prize: '$100 Amazon Gift Card',
  },
]

export default function TwelveDaysOfNeat() {
  const [flippedCards, setFlippedCards] = useState({})
  const [showAllDates, setShowAllDates] = useState(false)

  const getOrdinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd']
    const v = n % 100
    return s[(v - 20) % 10] || s[v] || s[0]
  }

  const today = new Date().getDate()
  const startingDay = 13

  useEffect(() => {
    const initialFlippedCards = {}
    cards.forEach((_, index) => {
      const cardDate = startingDay + index
      if (cardDate <= today) {
        initialFlippedCards[index] = true
      }
    })
    setFlippedCards(initialFlippedCards)
  }, [today])

  const toggleCard = (index) => {
    setFlippedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  const handleCardsToggle = () => {
    const newFlippedCards = {}
    if (showAllDates) {
      cards.forEach((_, index) => {
        const cardDate = startingDay + index
        if (cardDate > today) {
          newFlippedCards[index] = false
        } else {
          newFlippedCards[index] = true
        }
      })
    } else {
      cards.forEach((_, index) => {
        newFlippedCards[index] = true
      })
    }
    setFlippedCards(newFlippedCards)
    setShowAllDates(!showAllDates)
  }

  return (
    <Layout.Content>
      <Section wrapperClassName={styles.neatDaysHero}>
        <Rows>
          <Row className={styles.heroInner}>
            <Column>
              <div className={styles.heroLeft}>
                <Image
                  alt="Christmas tree"
                  src={calendarTree}
                />
                <div>
                  <h3>Get in the holiday mood</h3>
                  <h2>12 Days of Neat</h2>
                  <h3 className={styles.fancyText}>Starts December 13th, 2024</h3>
                </div>
              </div>
            </Column>
            <Column>
              <Image
                alt="How it works"
                src={calendarLabel}
                style={{ margin: '0 auto' }}
              />
              <p>Each day during our "12 Days of Neat" check to see what we have to offer and what you have to do to
                participate. You can uncover all upcoming dates at once to see if you need to perform a task earlier.
                We will collect all submissions for that day to randomly choose a winner for that day.
              </p>
            </Column>
          </Row>
        </Rows>
      </Section>

      <Section className={styles.neatCardsSection} paddingBottom={24}>
        <Rows>
          <Row center textCenter>
            <h2>Click the dates to uncover Neat's surprises</h2>
          </Row>
          <Row center>
            <Button
              messageId={showAllDates ? 'cta.coverDates' : 'cta.uncoverDates'}
              onClick={handleCardsToggle}
              size="xlarge"
              variant="success"
            />
          </Row>
          <div className={styles.neatCardsWrapper}>
            <div className={styles.neatCards}>
              {cards.map((card, index) => {
                const uniqueKey = `${card.title}-${index}`
                const day = startingDay + index
                const ordinal = getOrdinal(day)
                const isFlipped = flippedCards[index]

                return (
                  <div
                    key={uniqueKey}
                    className={`${styles.neatCard} ${isFlipped ? styles.flipped : ''}`}
                    onClick={() => toggleCard(index)}
                    role="button"
                    tabIndex={0}
                  >
                    <div className={styles.neatCardInnerFront}>
                      <h3>{day}</h3>
                      <Image
                        alt={card.title}
                        src={halfCircle}
                      />
                    </div>

                    <div className={styles.neatCardInnerBack}>
                      <h2>December {day}{ordinal}</h2>
                      <h3>{card.title}</h3>
                      <div onClick={(e) => e.stopPropagation()} role="button" tabIndex={0}>{day > today && card.alternativeText ? card.alternativeText : card.text}</div>
                      {card.prize && <p className={styles.neatCardPrize}>{card.prize}</p>}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <Row className={styles.disclaimer} textCenter>
            <p><span>Disclaimer:</span> *NO PURCHASE NECESSARY. Legal residents of the 50 United States (D.C.) 18
              and older. The Neat Company, Inc. Employees are not eligible to win prizes. Starts 12/13/24
              at 12:01 a.m. ET and ends 12/24/24 at 11:59 p.m. ET. To play including how to enter without purchase,
              prizes, and odds, see the <a href="https://www-data.neat.com/documents/12%20Days%20of%20Neat%20Sweepstakes%20Rules.pdf" rel="noreferrer" target="_blank">Official Rules</a>. Void where prohibited.
            </p>
          </Row>
        </Rows>
      </Section>

    </Layout.Content>
  )
}

TwelveDaysOfNeat.layoutProps = {
  pageId,
  shouldRobotsIndex: false,
}
